import React, { useState, useEffect } from 'react';
import QuoteBuilderNavSection from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderNavSection.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'
import styles from 'components/layout_and_quote_builder/_style.module.scss';

const GeneralNavSection = ( { } ) => {
  const [index, setIndex] = useState( -1 )
  const [_index, set_Index] = useState( -1 )
  const [config, setConfig] = useState( {} )
  const [payload, setPayload] = useState( {} )
  const [presentedOptions, setPresentedOptions] = useState( {} )
  const [navSection, setNavSection] = useState( {} )

  const on_nav_section_general_part_type = (msg) => {
    if(index > -1 ) { return }

    const detail = msg.detail;

    setIndex( () => detail.index )
    set_Index( () => detail._index )
    setConfig( () => detail.config )
    setPayload( () => detail.payload )
    setPresentedOptions( () => detail.presentedOptions )
    setNavSection( () => detail.navSection )
  }

  MyEventListener([
    {
      key: 'nav_section_general_part_type',
      callback: on_nav_section_general_part_type
    }
  ])

  if(index == -1) { return ""}

  return (
    <>
    <div className={styles.LayoutAndQuoteBuilderNavSection}>

      <div className={styles.nav_section}>

        {navSection.label != undefined && (
          <div className="col-lg-12">
            <div className="promo-block">
              <div className="promo-text"> {navSection.label} </div>
            </div>
          </div>
        )}

          <QuoteBuilderNavSection
            index={navSection.index}
            config={config}
            payload={payload}
            presentedOptions={presentedOptions}
            key={`navSection_99`}
            navSection={navSection}
          />

      </div>
    </div>
    <br />
    <br />
    </>
  );



}

export default GeneralNavSection;